import { useQuery } from "react-query";
import {
  apiListCuideoDiscardedValuations,
  IApiListCuideoDiscardedValuationsParams,
} from "../../../../../api/valuation/apiListCuideoDiscardedValuations";
import {
  ExtractFnReturnType,
  QueryConfig,
} from "../../../../../lib/react-query";
import { valuationKeys } from "./valuation.query-keys";

type QueryFnType = typeof apiListCuideoDiscardedValuations;

type TUseCuideoDiscardedValuationsOptions = {
  params: IApiListCuideoDiscardedValuationsParams;
  config?: QueryConfig<QueryFnType>;
};

export const useCuideoDiscardedValuations = ({
  params,
  config,
}: TUseCuideoDiscardedValuationsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: valuationKeys.cuideoDiscardedForCandidate(params),
    queryFn: () => apiListCuideoDiscardedValuations(params),
  });
};
